<template>
  <v-container grid-list-sm>
    <v-form ref="paymentform" lazy-validation>
    <v-layout row wrap>
      <v-card elevation="0" class="pt-0">
        <v-card-text fill-height class="pt-0">
          <v-container fluid grid-list-sm class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  :label="(transaction.payment_type==='ach') ? 'Account Holder Name' : 'Card Holder Name'"
                  v-model="fields.card_name"
                  append-icon="fa-user"
                  :rules="nameRules"
                  box
                  hide-details
                  required
                ></v-text-field>
              </v-flex>

              <template v-if="transaction.payment_type==='ach'">
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Account Number"
                    v-model="fields.ach_account_number"
                    append-icon="fa-institution"
                    :rules="accountRules"
                    box
                    hide-details
                    required
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Routing Number"
                    v-model="fields.ach_routing_number"
                    append-icon="fa-exchange"
                    :rules="routingRules"
                    mask="#########"
                    box
                    hide-details
                    required
                  />
                </v-flex>
                <v-flex xs12 sm6>
                  <v-select
                    label="Type"
                    v-model="fields.ach_type"
                    :items="achTypes"
                    box
                    hide-details
                    required
                  />
                </v-flex>
              </template>

              <template v-else>
                <v-flex xs12 sm6>
                  <v-text-field
                    label="Card Number"
                    v-model="fields.card_number"
                    :append-icon="(!cardType || cardType==='unknown') ? 'fa-credit-card' : ''"
                    :mask="cardMask"
                    :rules="cardRules"
                    box
                    hide-details
                    required
                  >
                    <img slot="append" :src="'/static/cards/' + cardType + '.svg'" height="24px" v-if="cardType && cardType!=='unknown'" />
                  </v-text-field>
                </v-flex>
                <v-flex sm6 class="hidden-xs-only">
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="Expiration"
                    type="tel"
                    v-model="fields.card_expiration"
                    append-icon="fa-calendar"
                    mask="## / ##"
                    :rules="expirationRules"
                    box
                    hide-details
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm3>
                  <v-text-field
                    label="CVV"
                    type="test"
                    v-model="fields.card_cvv"
                    append-icon="fa-eye"
                    :rules="cvvRules"
                    :mask="cvvMask"
                    box
                    hide-details
                    required
                  ></v-text-field>
                </v-flex>
              </template>
            </v-layout>

            <v-divider class="primary mt-2 mb-2" />

            <v-layout row wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  label="Address"
                  v-model="fields.billing_address"
                  append-icon="fa-home"
                  box
                  hide-details
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  label="City"
                  v-model="fields.billing_city"
                  append-icon="fa-compass"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
              <v-flex xs6 sm6>
                <StateField
                  v-model="fields.billing_state"
                  icon="fa-info-circle"
                  :textfield="fields.billing_country !== 'USA'"
                ></StateField>
              </v-flex>
              <v-flex xs6 sm6>
                <v-text-field
                  label="Postal Code"
                  v-model="fields.billing_postalcode"
                  :rules="transaction.payment_type !== 'ach' ? postalcodeRules : []"
                  append-icon="fa-info-circle"
                  box
                  hide-details
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-container fluid grid-list-lg class="pa-0">
            <v-layout row wrap>
              <v-spacer></v-spacer>
              <v-flex xs3>
                <v-btn block large @click="closeModal">Cancel</v-btn>
              </v-flex>
              <v-flex xs3>
                <v-btn block large @click="save" color="primary" :disabled="submitDisabled">Confirm</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import Moment from 'moment'
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import CashDiscountMixin from '@/mixins/cashDiscount'
import DisplayMixin from '@/mixins/display'
import RecurringMixin from '@/mixins/recurring'
import StoreMixin from '@/store/mixin'
import UtilityMixin from '@/mixins/utility'
import ValidationMixin from '@/mixins/validation'

import StateField from '@/components/forms/StateDropdown.vue'

export default {
  components: { StateField },

  mixins: [
    ApiMixin,
    AuthMixin,
    CashDiscountMixin,
    DisplayMixin,
    RecurringMixin,
    StoreMixin,
    UtilityMixin,
    ValidationMixin
  ],

  data: function () {
    return {
      enabled: false,

      fields: {
        token: null,
        card_name: '',
        card_name_original: '',
        card_number: '',
        card_number_original: '',
        card_expiration: '',
        card_expiration_original: '',
        card_cvv: null,
        ach_routing_number: '',
        ach_routing_number_original: '',
        ach_account_number: '',
        ach_account_number_original: '',
        ach_type: 'CHECKING',
        ach_type_original: 'CHECKING',
        billing_address: '',
        billing_address_original: '',
        billing_city: '',
        billing_city_original: '',
        billing_state: '',
        billing_state_original: '',
        billing_postalcode: '',
        billing_postalcode_original: '',
        billing_country: '',
        billing_country_original: '',
        billing_phone: null,
        billing_phone_original: null,
        billing_email: null,
        billing_email_original: null
      },

      achTypes: [
        {value: 'CHECKING', text: 'Personal checking'},
        {value: 'SAVINGS', text: 'Personal savings'},
        {value: 'BUSINESSCK', text: 'Business checking'}
      ],

      nameRules: [
        (v) => !!v || 'Name is required'
      ],
      cardRules: [
        (v) => !!v || 'Card number is required',
        (v) => this.validateCardNumber(v) || 'Card number is invalid'
      ],
      cvvRules: [
        (v) => !!v || 'CVV is required'
      ],
      expirationRules: [
        (v) => !!v || 'Expiration is required'
      ],
      routingRules: [
        (v) => !!v || 'Routing number is required',
        (v) => /^\d+$/.test(v) || 'Routing number must be only digits',
        (v) => v.length === 9 || 'Routing number must be nine digits',
        (v) => this.validateABA(v) || 'Routing number is invalid'
      ],
      accountRules: [
        (v) => !!v || 'Account number is required',
        (v) => (v.length < 18) || 'Account number must be less than 18 digits'
      ],
      addressRules: [
        (v) => !!v || 'Address is required'
      ],
      cityRules: [
        (v) => !!v || 'City is required'
      ],
      stateRules: [
        (v) => !!v || 'State is required'
      ],
      postalcodeRules: [
        (v) => !!v || 'Postal code is required'
      ]
    }
  },

  props: {
    terminal: Object,
    transaction: Object,
    finalTransaction: Object
  },

  // beforeDestroy () {},

  // mounted () {
  //   this.load()
  // },

  // updated () {
  //   this.load()
  // },

  watch: {
    transaction: function () {
      this.load()
    }
  },

  computed: {
    submitDisabled: function () {
      // return this.$refs.paymentform.validate()
      return false
    },

    cardMask () {
      if (this.cardType === 'amex') {
        return '#### ###### #####'
      } else if (this.cardType === 'diners') {
        return '#### ###### #####'
      } else if (this.cardType === 'discover') {
        return '#### #### #### ####'
      } else if (this.cardType === 'jcb') {
        return '#### #### #### ####'
      } else if (this.cardType === 'jcb15') {
        return '#### ###### #####'
      } else if (this.cardType === 'maestro') {
        return '#### #### #### ####'
      } else if (this.cardType === 'mastercard') {
        return '#### #### #### ####'
      } else if (this.cardType === 'unionpay') {
        return '#### #### #### ####'
      } else if (this.cardType === 'visa') {
        return '#### #### #### ####'
      }
      return '#### #### #### ####'
    },

    cvvMask () {
      if (this.cardType === 'amex' || this.cardType === 'diners' || this.cardType === 'jcb15') {
        return '####'
      }
      return '###'
    },

    cardType () {
      let amex = /^3[47]\d{0,13}/
      let diners = /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/
      let discover = /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/
      let jcb = /^(?:35\d{0,2})\d{0,12}/
      let jcb15 = /^(?:2131|1800)\d{0,11}/
      let maestro = /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/
      let mastercard = /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/
      let unionpay = /^62\d{0,14}/
      let visa = /^4\d{0,15}/

      if (amex.test(this.fields.card_number)) {
        return 'amex'
      } else if (diners.test(this.fields.card_number)) {
        return 'diners'
      } else if (discover.test(this.fields.card_number)) {
        return 'discover'
      } else if (jcb.test(this.fields.card_number)) {
        return 'jcb'
      } else if (jcb15.test(this.fields.card_number)) {
        return 'jcb15'
      } else if (maestro.test(this.fields.card_number)) {
        return 'maestro'
      } else if (mastercard.test(this.fields.card_number)) {
        return 'mastercard'
      } else if (unionpay.test(this.fields.card_number)) {
        return 'unionpay'
      } else if (visa.test(this.fields.card_number)) {
        return 'visa'
      }
      return 'unknown'
    }
  },

  methods: {
    closeModal () {
      Bus.$emit('closeModifyModal')
    },

    async load () {
      this.fields.card_name_original = this.fields.card_name = this.transaction.card_name
      this.fields.ach_routing_number_original = this.fields.ach_routing_number = this.transaction.ach_aba
      this.fields.ach_type = this.fields.ach_type = this.transaction.ach_account_type
      this.fields.billing_address_original = this.fields.billing_address = this.transaction.billing_address
      this.fields.billing_city_original = this.fields.billing_city = this.transaction.billing_city
      this.fields.billing_state_original = this.fields.billing_state = this.transaction.billing_state
      this.fields.billing_postalcode_original = this.fields.billing_postalcode = this.transaction.billing_postal_code
      this.fields.billing_country_original = this.fields.billing_country = this.transaction.billing_country
      this.fields.billing_phone_original = this.fields.billing_phone = this.transaction.billing_phone
      this.fields.billing_email_original = this.fields.billing_email = this.transaction.billing_email

      // this.$refs.paymentform.resetValidation()
    },

    async save () {
      let responses = []
      let hasError = false
      let immediateError = ''

      try {
        Bus.$emit('openWaitModal')

        // attempt to make new transaction
        // modify original transaction to cancel if settled
        // void original if unsettled
        // create new last payment if needed
        // void previous last payment if needed

        // @TODO recurring_start needs to be offset to _next_ recurring start

        // attempt to make new transaction
        let options = {
          account_id: this.transaction.account_id,
          terminal_id: this.transaction.terminal_id,
          transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
          request_type: 'sale',
          tokenize: true,
          is_recurring: true,
          is_installment: 1,
          recurring: (this.transaction.modify_recurring_type ? this.transaction.modify_recurring_type : this.transaction.recurring_type),
          recurring_offset: new Date().getTimezoneOffset() / 60,
          // recurring_start_date: (this.transaction.modify_recurring_start ? this.transaction.modify_recurring_start : this.transaction.recurring_start),
          recurring_end_date: Moment.utc(this.transaction.modify_recurring_end ? this.transaction.modify_recurring_end : this.transaction.recurring_end).format('YYYY-MM-DD'),
          amount: ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100,
          // fee: (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100,
          order_number: this.transaction.order_number,
          customer_po: this.transaction.customer_po,
          custom_field_1: this.transaction.custom_field_1,
          custom_field_2: this.transaction.custom_field_2,
          custom_field_3: this.transaction.custom_field_3,
          // custom: this.transaction.custom,
          custom: JSON.stringify(this.transaction.custom),
          notes: this.transaction.notes,
          card_name: this.fields.card_name,
          billing_address: this.fields.billing_address,
          billing_city: this.fields.billing_city,
          billing_state: this.fields.billing_state,
          billing_postalcode: this.fields.billing_postalcode,
          billing_country: this.transaction.billing_country
        }

        let installments = this.getInstallments(this.transaction)
        for (let day of installments) {
          if (Moment().isAfter(day)) {
            continue
          }
          options.recurring_start_date = day.format('YYYY-MM-DD')
          break
        }

        if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && !this.transaction.is_fee_waived) {
          options.fee = (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100
        } else if (this.transaction.is_cashdiscount && this.transaction.request_type !== 'ach' && this.transaction.is_fee_waived) {
          options.waive_fee = this.transaction.is_fee_waived
          options.fee_waived = (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100
        }

        if (this.transaction.request_type === 'ach') {
          options.request_type = 'ach'
          options.ach_routing_number = this.fields.ach_routing_number
          options.ach_account_number = this.fields.ach_account_number
          options.ach_type = this.fields.ach_type
          options.ach_is_authorized = this.transaction.ach_is_authorized
          options.ach_authorization = 'onfile'
        } else {
          options.card_number = this.fields.card_number
          options.card_cvv = this.fields.card_cvv
          options.card_month = this.fields.card_expiration.slice(0, 2)
          options.card_year = this.fields.card_expiration.slice(-2)
        }

        let result = await this.api({
          method: 'post',
          url: `/terminal/payment`,
          data: options
        })

        if (result.data.response.ResponseText === 'APPROVED' || result.data.response.ResponseText === 'PENDING' || result.data.response.ResponseText === 'CHECK ACCEPTED') {
          responses.push({
            transaction: result.data.response.Transaction,
            id: result.data.response.Transaction.id,
            custom_tracking_id: result.data.response.Transaction.custom_tracking_id,
            status: 'success'
          })
        } else {
          hasError = true
          responses.push({
            id: this.transaction.id,
            custom_tracking_id: this.transaction.custom_tracking_id,
            status: 'error',
            message: result.data.response.ResponseText,
            error: result.data.response.ErrMsg || ''
          })
          immediateError = result.data.response.ResponseText
          if (result.data.response.ErrMsg && result.data.response.ErrMsg !== result.data.response.ResponseText) {
            immediateError += ': ' + result.data.response.ErrMsg
          }
        }

        // modify original transaction to cancel if settled
        if (!hasError && this.transaction.settled) {
          let modifyOptions = {
            account_id: this.transaction.account_id,
            terminal_id: this.transaction.terminal_id,
            token_id: this.transaction.token_id,
            unique_id: this.transaction.tracking_id,
            transaction_group_id: this.transaction.transaction_group_custom_tracking_id,
            is_recurring: true,
            is_installment: 1,
            recurring_type: 'none',
            recurring_offset: new Date().getTimezoneOffset() / 60,
            recurring_start_date: (this.transaction.modify_recurring_start ? this.transaction.modify_recurring_start : this.transaction.recurring_start),
            recurring_end_date: (this.transaction.modify_recurring_end ? this.transaction.modify_recurring_end : this.transaction.recurring_end),
            total_amount: ((this.transaction.modify_total_amount ? this.transaction.modify_total_amount : this.transaction.total_amount) - (this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount)) / 100, // required for FAPS
            waive_fee: this.transaction.is_fee_waived,
            fee_amount: this.transaction.is_fee_waived ? 0 : ((this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100), // required for modify endpoint to properly calculate
            fee_waived: this.transaction.is_fee_waived ? ((this.transaction.modify_fee_amount ? this.transaction.modify_fee_amount : this.transaction.fee_amount) / 100) : 0
          }

          let modifyResult = await this.api({
            method: 'post',
            url: `/terminal/modify`,
            data: modifyOptions
          })

          if (modifyResult.data) {
            if (modifyResult.data.response.ResponseText === 'MODIFY ACCEPTED') {
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'success'
              })
            } else {
              hasError = true
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'error',
                message: modifyResult.data.response.ResponseText,
                error: modifyResult.data.response.ErrMsg || ''
              })
            }
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: 'unknown',
              error: 'unknown'
            })
          }
        }

        // void original if unsettled
        if (!hasError && !this.transaction.settled) {
          let voidOptions = {
            terminal_id: this.transaction.terminal_id,
            transaction_id: this.transaction.id
          }

          let voidResult = await this.api({
            method: 'post',
            url: `/terminal/void`,
            data: voidOptions
          })

          if (voidResult.data) {
            if (voidResult.data.response.ActionCode === '000') {
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'success'
              })
            } else {
              hasError = true
              responses.push({
                id: this.transaction.id,
                custom_tracking_id: this.transaction.custom_tracking_id,
                status: 'error',
                message: result.data.response.ResponseText,
                error: voidResult.data.response.ErrMsg || ''
              })
            }
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: 'unknown',
              error: 'unknown'
            })
          }
        }

        // create new last payment if needed
        if (!hasError && Object.keys(this.finalTransaction).length) {
          let lastOptions = {
            account_id: this.finalTransaction.account_id,
            terminal_id: this.finalTransaction.terminal_id,
            token: result.data.response.Transaction.token,
            billing_id: result.data.response.Transaction.billing_id,
            transaction_group_id: this.finalTransaction.transaction_group_custom_tracking_id,
            request_type: 'sale',
            is_installment: 1,
            close_date: Moment.utc(this.finalTransaction.future_post).format('YYYY-MM-DD'),
            amount: ((this.finalTransaction.modify_total_amount ? this.finalTransaction.modify_total_amount : this.finalTransaction.total_amount) - (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount)) / 100,
            order_number: this.finalTransaction.order_number,
            customer_po: this.finalTransaction.customer_po,
            custom_field_1: this.finalTransaction.custom_field_1,
            custom_field_2: this.finalTransaction.custom_field_2,
            custom_field_3: this.finalTransaction.custom_field_3,
            custom: JSON.stringify(this.finalTransaction.custom),
            notes: this.finalTransaction.notes,
            card_name: this.fields.card_name,
            billing_address: this.fields.billing_address,
            billing_city: this.fields.billing_city,
            billing_state: this.fields.billing_state,
            billing_postalcode: this.fields.billing_postalcode,
            billing_country: this.transaction.billing_country
          }

          if (this.finalTransaction.request_type === 'ach') {
            lastOptions.request_type = 'ach'
            lastOptions.ach_is_authorized = this.finalTransaction.ach_is_authorized
            lastOptions.ach_authorization = 'onfile'
            lastOptions.ach_type = this.fields.ach_type
          }

          if (this.finalTransaction.is_cashdiscount && this.finalTransaction.request_type !== 'ach' && !this.finalTransaction.is_fee_waived) {
            lastOptions.fee = (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount) / 100
          } else if (this.finalTransaction.is_cashdiscount && this.finalTransaction.request_type !== 'ach' && this.finalTransaction.is_fee_waived) {
            lastOptions.waive_fee = this.finalTransaction.is_fee_waived
            lastOptions.fee_waived = (this.finalTransaction.modify_fee_amount ? this.finalTransaction.modify_fee_amount : this.finalTransaction.fee_amount) / 100
          }

          let lastResult = await this.api({
            method: 'post',
            url: `/terminal/payment`,
            data: lastOptions
          })

          if (lastResult.data.response.ResponseText === 'APPROVED' || lastResult.data.response.ResponseText === 'PENDING' || lastResult.data.response.ResponseText === 'CHECK ACCEPTED') {
            responses.push({
              transaction: lastResult.data.response.Transaction,
              id: lastResult.data.response.Transaction.id,
              custom_tracking_id: lastResult.data.response.Transaction.custom_tracking_id,
              status: 'success'
            })
          } else {
            hasError = true
            responses.push({
              id: this.transaction.id,
              custom_tracking_id: this.transaction.custom_tracking_id,
              status: 'error',
              message: lastResult.data.response.ResponseText,
              error: lastResult.data.response.ErrMsg || ''
            })
          }
        }

        // void previous last payment if needed
        if (!hasError && Object.keys(this.finalTransaction).length && !this.finalTransaction.settled) {
          // void original unsettled
          let lastVoidOptions = {
            terminal_id: this.finalTransaction.terminal_id,
            transaction_id: this.finalTransaction.id
          }

          let lastVoidResult = await this.api({
            method: 'post',
            url: `/terminal/void`,
            data: lastVoidOptions
          })

          if (lastVoidResult.data) {
            if (lastVoidResult.data.response.ActionCode === '000') {
              responses.push({
                id: this.finalTransaction.id,
                custom_tracking_id: this.finalTransaction.custom_tracking_id,
                status: 'success'
              })
            } else {
              hasError = true
              responses.push({
                id: this.finalTransaction.id,
                custom_tracking_id: this.finalTransaction.custom_tracking_id,
                status: 'error',
                message: result.data.response.ResponseText,
                error: lastVoidResult.data.response.ErrMsg || ''
              })
            }
          } else {
            hasError = true
            responses.push({
              id: this.finalTransaction.id,
              custom_tracking_id: this.finalTransaction.custom_tracking_id,
              status: 'error',
              message: 'unknown',
              error: 'unknown'
            })
          }
        }
      } catch (err) {
        // Bus.$emit('openModal', {status: 'error', message: err})
        // immediateError = err
        responses.push({
          id: 0,
          custom_tracking_id: 0,
          status: 'error',
          message: err,
          error: 'Unknown Error'
        })
      } finally {
        Bus.$emit('closeWaitModal')
      }

      if (immediateError) {
        Bus.$emit('openModal', {status: 'error', message: immediateError})
      } else if (!responses.length) {
        Bus.$emit('openModal', {status: 'info', message: 'Nothing to process'})
      } else if (hasError) {
        // Bus.$emit('openModal', {status: 'error', message: responses})
        console.log('ERROR')
        console.log(responses)
        Bus.$emit('openModal', {status: 'error', message: 'There has been an issue modifying the payment information. Please contact support'})
      } else {
        Bus.$emit('openModal', {status: 'success', message: 'Installment plan has been modified'})
        Bus.$emit('reloadPlan')
        this.closeModal()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plans/ModifyPayment.vue